"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel["None"] = "NONE";
    LogLevel["Fatal"] = "FATAL";
    LogLevel["Error"] = "ERROR";
    LogLevel["Warn"] = "WARN";
    LogLevel["Info"] = "INFO";
    LogLevel["Debug"] = "DEBUG";
    LogLevel["Trace"] = "TRACE";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
//# sourceMappingURL=LogLevel.js.map